import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Navigation, EffectFade } from 'swiper/modules'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.$slider = this.$('slider')[0]
    this.$prev = this.$('prev')[0]
    this.$next = this.$('next')[0]
  }

  init() {
    this.carousel = new Swiper(this.$slider, {
      modules: [Navigation, EffectFade],
      loop: true,
      effect: 'fade',
      speed: 1000,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: this.$prev,
        nextEl: this.$next,
      },
    })
  }
}
